import { convertLocaltoUTCDate } from "../../../services/DateFormatUtility";
import { Link } from "react-router-dom";
const getReportLink = (row, value) => (
    <Link
        to={`/company-verification-report/${row.original.companyVerificationReportId}`}
        onClick={(e) => e.stopPropagation()}
        style={{
            color: "inherit",
            textDecoration: "none",
        }}
    >
        {value}
    </Link>
);

export const CER_WCN_TABLE_COLUMNS = [

    {
        header: "WCN",
        enableHiding: false,
        accessorKey: "wcnNumber",
        maxSize: 80,
        enableSorting: false,
        Cell: ({ row }) =>
            getReportLink(row, row.original.wcnNumber),
    },
     {
        header: "WCN Company Name",
        accessorKey: "companyName", // confirm exact key with backend
        minSize: 200,
        enableSorting: false,
        Cell: ({ row }) =>
            getReportLink(row, row.original.companyName),
    },
    {
        header: "Company Name",
        accessorKey: "xmlCompanyName",
        minSize: 200,
        enableSorting: false,
        Cell: ({ row }) =>
            getReportLink(row, row.original.xmlCompanyName),
    },
    {
        header: "Company IMO Number",
        accessorKey: "companyImoNumber",
        enableSorting: false,
        Cell: ({ row }) =>
            getReportLink(row, row.original.companyImoNumber),
    },
    {
        header: "CER ID",
        accessorKey: "cvrId",
        enableSorting: false,
        Cell: ({ row }) =>
            getReportLink(row, row.original.cvrId),
    },
    {
        header: "Modified Date",
        accessorKey: "modifiedDate",
        minSize: 200,
        enableSorting: false,
       enableColumnFilter: false,
       enableColumnActions: false,
       Cell: ({ cell, row }) => {
            const value = cell.getValue();

            if (!value) return "";

            const formattedDate = new Date(value).toLocaleString("en-GB", {
                timeZone: "UTC",
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            }).replace(",", "");

            return getReportLink(row, formattedDate);
        },
    },
    // {
    //     header: "Status",
    //     accessorKey: "status",
    //     enableSorting: false,
    // },

]